// The app's own custom scheme (Info.plist CFBundleURLSchemes, the Android
// manifest's scheme intent filter, and every server-built `nativeUrl`).
export const APP_SCHEME = 'com.bosko.app:';

// Placeholder origin for resolving paths; only its sameness matters.
const SAME_ORIGIN = 'https://app.invalid';

// Path (+ query) to visit for a URL the OS handed to the app via appUrlOpen.
//
// Custom-scheme URLs are sliced as strings instead of parsed: engines disagree
// on non-special schemes. WebKit and Chromium >= 130 read
// `com.bosko.app://pl/login` as host "pl" + path "/login", but Chromium < 130 —
// the Android 7 WebView is frozen at 119 — reads host "" + path "//pl/login",
// and visiting "//pl/login" resolves protocol-relative to https://pl/login.
// Universal / App Links (https) carry the real host, which is never folded in.
export function deepLinkPath(url) {
  const candidate = url.toLowerCase().startsWith(APP_SCHEME)
    ? `/${url.slice(APP_SCHEME.length).replace(/^\/+/, '')}`
    : (({ pathname, search }) => pathname + search)(new URL(url));

  // Any link can be sent to the app, so the result must stay on its own
  // origin. URL parsing turns a backslash into "/" and drops tabs and
  // newlines, so "/<backslash>evil.example" or "//evil.example" would
  // otherwise be visited as another host inside the app's WebView.
  const resolved = new URL(candidate, SAME_ORIGIN);
  if (resolved.origin !== SAME_ORIGIN) return '/';
  return resolved.pathname + resolved.search;
}

// An in-app screen, in English (/app/…) or under a locale prefix (/pl/app/…,
// /pt-BR/app/…, /es-419/app/…) — the "app" segment itself is never translated.
function isLocaleSegment(segment = '') {
  const [language, region] = segment.split('-');
  return (
    /^[a-z]{2}$/.test(language) &&
    (region === undefined || /^[A-Za-z0-9]{2,3}$/.test(region))
  );
}

export function isAppPath(path) {
  const [, first, second, third] = path.split('/');
  if (first === 'app') return second !== undefined;
  return isLocaleSegment(first) && second === 'app' && third !== undefined;
}

// `com.bosko.app:/` with no path means "take me back to the app where I was":
// the web confirmation pages use it when the destination is wherever the user
// left off, not a specific screen.
export function isBareReturn(path) {
  return path === '/';
}
